export default __webpack_public_path__ + "static/messageIcon-30656ba40937dc219bb4c61e231ec68e.svg";